<script lang="ts" setup>
import type { CarImageSize } from '@autobid/ui/types/Car'
import type { CarDetailsImage } from '@autobid/ui/types/components/CarDetails'
import { useCarGallery } from '@autobid/ui/composables/car/useCarGallery'
import { generateImageSizesFromArray } from '@autobid/ui/utils/car/generateImageSizes'

interface Props {
  image: CarDetailsImage
  overlaySize?: 'small' | 'big'
}

const props = defineProps<Props>()

const THUMBNAIL_SIZES = {
  m: 639,
}
const links = generateImageSizesFromArray('hd', [props.image])[0].links

const { injectShowGallery, openCarGallery } = useCarGallery()
const showGallery = injectShowGallery()

function handleClickImage(links: Record<CarImageSize, string>) {
  showGallery.value = true
  openCarGallery(links)
}
</script>

<template>
  <button
    :aria-label="$t('car-details.open-gallery')"
    class="relative h-full"
    @click="handleClickImage(links)"
  >
    <CommonPicture
      :images="links"
      :sizes="THUMBNAIL_SIZES"
      default-size="s"
      class="relative z-10 object-cover"
      :alt="image.description.categoryLabel"
      loading="lazy"
    />
    <SectionsDetailsElementsImageHoverOverlay :size="overlaySize ?? 'big'" />
  </button>
</template>
